import MgpTooltip from "../../elements/MgpTooltip/MgpTooltip";


type DocumentRequiredElementProps = {
   icon: string;
   title: string;
   text: string;
   infoText?: boolean;
   handleClick?: any;
   tooltip?: string
};

export default function DocumentRequiredElement({icon, title, text, infoText, handleClick, tooltip}: DocumentRequiredElementProps) { 
    return(
        <div className="m-y-xs" style={{display: "flex", alignItems: "center"}}>
            <i className={`${icon} fz-lg m-x-sm fushia`}></i>
            <div className="m-x-xs">
                <div className="">
                    <p className="fw-bold fz-sm bleu ">
                        {title}
                        { infoText &&
                        tooltip === undefined &&
                        <button onClick={handleClick} className="info-badge info-button" title="Cliquer pour voir les instructions."><span className=''>i</span></button> }
                        {tooltip &&
                        tooltip?.length > 0 &&
                        <MgpTooltip text={tooltip} maxWidth="550px">
                             <p 
                                className='info-badge info-icon' 
                                style={{
                                    marginTop: '-14px', 
                                    height: '15px', 
                                    width: '15px',
                                     fontSize: '11px'
                                }}>i</p>
                        </MgpTooltip>}
                    </p>
                </div>
               
                <div className="text fz-xs " dangerouslySetInnerHTML={{ __html: text }}></div>
               
            </div>
        </div>
    )
}